@import '../../theme/colors';

.fieldset {
  border: 0;
  border-top: 1px solid #d1cece;
  padding: 0;
  padding-top: 20px;
  margin: 0;
  margin-top: 20px;

  .twoColumn {
    > div {
      width: 48%;
      margin-right: 2%;
    }

    > div:last-child {
      margin-left: 2%;
      margin-right: 0;
    }
  }

  .threeColumn {
    > div {
      width: 31.33%;
      margin-right: 2%;
    }

    > div:last-child {
      margin-left: 2%;
      margin-right: 0;
    }
  }
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ccc;
  z-index: 9999;
  opacity: 0.6;
}

.fixedCircularProgress {
  position: fixed;
  top: 60vh;
  left: 50%;
}

.searchBar {
  position: relative;
  border: 1px solid #115a80;
  border-radius: 15px;
  height: 30px;
  width: 268px;

  input {
    box-sizing: border-box;
    border: none;
    border-radius: 15px;
    width: 100%;
    line-height: 28px;
    padding-left: 58px;
    font-size: 14px;
    color: #00223c;
    cursor: pointer;
    outline-width: 0;
  }

  &:focus-within {
    border: 1px solid #00aafc;
  }

  svg {
    position: absolute;
    left: 32px;
    top: 7px;
    font-size: 20px;
  }
}

.submitButton {
  width: 200px;
  height: 30px;

  button {
    font-weight: 400;
    border-radius: 2px;
    font-family: var(--font-family__heading);
  }
}

.breadcrumbs {
  display: flex;
  align-items: center;
  height: 28px;
  margin: 27px 0 22px;

  svg {
    margin: 0 13px;
  }

  a {
    font-family: var(--font-family__heading);
    text-decoration: none;
    font-size: 20px;
    color: #006da8;
  }
}

.tertiary {
  font-family: var(--font-family__heading);
  font-weight: 300;
  line-height: 1.45;
  font-size: 11px;
  color: $oceanBlue;
  text-transform: uppercase;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
}

.secondaryButton {
  min-width: min-content;
  white-space: nowrap;
  height: 20px !important;
  border-radius: 2px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  color: white !important;
  cursor: pointer !important;
  background-color: $secondaryBlue !important;
  font-size: 13px !important;
  font-family: var(--font-family__heading) !important;
  line-height: 1 !important;
  text-transform: none !important;
}

.secondaryButton:hover {
  background-color: $oceanBlue !important;
}

.secondaryButton:active {
  background-color: $seconaryActive !important;
}

.deactive {
  @extend .secondaryButton;
  background-color: $lightGrey !important;
}

.checkbox {
  height: 16px;
  width: 16px;
  border-radius: 3px;
  border: 1px solid $neutral-300;
  color: transparent !important;
  background-color: transparent;
  padding: 0;
  margin-right: 6px;
  box-sizing: border-box;

  path {
    color: transparent;
  }
}

.checkbox:hover {
  border: 1px solid $seconaryActive;
}

.checkboxActive {
  @extend .checkbox;

  svg {
    width: 20px;
    height: 20px;
  }

  path {
    color: $oceanBlue;
  }
}

.disabledMenuItem {
  padding-left: 10px !important;

  div {
    span {
      font-weight: 800 !important;
    }
  }
}

.formActions {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.singleFormAction {
  @extend .formActions;
  justify-content: flex-end;
}

.dialogContainer {
  height: 132px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .dialogHeader {
    margin-bottom: 15px;
  }

  .dialogButtonContainer {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;

    .buttonContainer {
      margin: 0 10px;
    }
  }
}
